import { useEffect } from 'react';
import { currentStage, PRODUCTION, DEVELOPMENT, STAGING, LOCAL } from '../../api/api';

const VERSION_KEY_MAP = {
  [PRODUCTION]: 'report-version',
  [DEVELOPMENT]: 'report-version-development',
  [STAGING]: 'report-version-staging',
  [LOCAL]: 'report-version-development'
}

const VersionChecker = () => {

  const getVersionKey = () => {
    return VERSION_KEY_MAP[currentStage] || VERSION_KEY_MAP[DEVELOPMENT];
  }

  useEffect(() => {
    const checkVersion = () => {
      try {
        const currentVersion = process.env.REACT_APP_VERSION;
        const currentVersionKey = getVersionKey();
        const storedVersion = localStorage.getItem(currentVersionKey);

        if (!currentVersion) {
          console.error('[Version Checker] Version not found');
          return;
        }

        if (storedVersion !== currentVersion) {
          localStorage.setItem(currentVersionKey, currentVersion);
          window.location.reload(true);

          // const userConfirmed = window.confirm(
          //   '發現新版本，是否立即重新載入？'
          // );
          // if (userConfirmed) {
          //   window.location.reload(true);
          // }
        }
      } catch (error) {
        console.error('[Version Checker] Error:', error);
      }
    };

    checkVersion();
  }, []);

  return null;
};

export default VersionChecker;